import { dbPost } from '../../apis/commonApi';

class ResVideoDetailController {
  constructor(
    { store, updateStore },
    { pageParam, setPageParam },
    { loadData, setLoadData },
    { scrData, setScrData },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.pageParam = pageParam;
    this.setPageParam = setPageParam;
    this.loadData = loadData;
    this.setLoadData = setLoadData;
    this.scrData = scrData;
    this.setScrData = setScrData;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearch() {
    const url = '/aia/analysis/video/res/stat.do';

    let response;

    try {
      response = await dbPost(url, {
        entSn: this.pageParam?.entSn,
        anlsAplyId: this.pageParam?.anlsAplyId,
        vdoId: this.pageParam?.vdoId,
      });

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.setLoadData(response);
        this.setScrData(response);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnSave() {
    const moveNextPage = () => {
      this.navigate('/ai/resVideoFrame', {
        state: {
          aiaRsltId: this.scrData?.[0]?.aiaRsltId,
          vdoId: this.scrData?.[0]?.vdoId,
        },
      });
    };

    const doSave = async () => {
      const validationRules = {
        weight: { presence: true },
        freqIntens: { presence: true },
      };

      const altKey = {
        weight: '무게',
        freqIntens: '빈도/강도',
      };

      for (let i = 0; i < this.loadData.length; i++) {
        const item = this.loadData[i];

        if (
          await this.validateService.validateJsCall(
            item,
            validationRules,
            altKey
          )
        ) {
          return;
        }
      }

      const url = '/aia/analysis/video/res/save.do';

      let response;

      try {
        response = await dbPost(url, {
          ...this.scrData?.[0],
          ...this.loadData?.[0],
          se: this.pageParam.se,
          aiaAplyId: this.pageParam.anlsAplyId,
        });

        if (response instanceof Error) {
          this.modalService.errorAlert(
            '처리중 에러가 발생하였습니다.',
            () => {}
          );
        } else {
          moveNextPage();
        }
      } catch (e) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      }
    };

    if (this.scrData?.[0]?.userPrslRsltYn === 'Y') {
      this.modalService.confirmAlert(
        { msg: '기존에 저장된 부가정보가 존재합니다. 수정하시겠습니까?' },
        [
          () => {
            doSave();
          },
          () => {
            moveNextPage();
          },
        ]
      );
    } else {
      doSave();
    }
  }

  async searchParamChange(model, value) {
    this.setSearchParam({ ...this.searchParam, [model]: value });
  }

  async loadDataChange(model, value) {
    if (model === 'freqIntens') {
      if (value === 'FQ_03') {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          unstableYn: 'Y',
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      } else {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          shockYn: 'Y',
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      }
    } else if (model === 'legSittedSupportedYn') {
      if (value === 'Y') {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          legSittedNotSupportedYn: 'N',
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      } else {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      }
    } else if (model === 'legSittedNotSupportedYn') {
      if (value === 'Y') {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          legSittedSupportedYn: 'N',
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      } else {
        const updatedLoadData = this.loadData.map(item => ({
          ...item,
          [model]: value,
        }));
        this.setLoadData(updatedLoadData);
      }
    } else {
      const updatedLoadData = this.loadData.map(item => ({
        ...item,
        [model]: value,
      }));
      this.setLoadData(updatedLoadData);
    }
  }

  // 파일 다운로드
  async fnDownload(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const arrayBuffer = await res.arrayBuffer();
      const blob = new Blob([arrayBuffer], {
        type: 'application/octet-stream',
      });
      const blobURL = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobURL;
      a.style.display = 'none';
      a.rel = 'noopener noreferrer';
      a.download = url.split('/').pop(); // 파일 이름 추출
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error('파일 다운로드 중 오류 발생:', error);
      alert('파일 다운로드 중 오류가 발생했습니다. 콘솔을 확인하세요.');
    }
  }
}

export default ResVideoDetailController;
